// tslint:disable-next-line: eofline
export class CTAButtonLayout {
	private _layoutContext: any;

	public get layoutContext(): any {
		return this._layoutContext;
	}

	public set layoutContext(value: any) {
		this._layoutContext = value;
	}
}
